import { VoiceSetting } from '../api/payment/donate-voice.api';

// Hàm thuần cho lời nhắn giọng nói khi donate — tách khỏi hook/component để test
// không phải dựng MediaRecorder/getUserMedia thật.

/** Ghi âm tối đa 15 giây, khớp với server (cắt ở 15.5s khi nén lại). */
export const MAX_VOICE_MS = 15000;

/** Thứ tự ưu tiên định dạng ghi âm trình duyệt hỗ trợ; không có cái nào ⇒ null (không ghi âm được). */
const MIME_CANDIDATES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4',
  'audio/ogg;codecs=opus',
];

export const pickRecorderMime = (
  isTypeSupported: ((m: string) => boolean) | undefined
): string | null => {
  if (!isTypeSupported) return null;
  return MIME_CANDIDATES.find((m) => isTypeSupported(m)) ?? null;
};

export type VoiceEligibility = 'off' | 'below-min' | 'ok';

export const voiceEligibility = (s: VoiceSetting | null, amount: number): VoiceEligibility => {
  if (!s || !s.enabled) return 'off';
  if (amount < s.minCa) return 'below-min';
  return 'ok';
};

/** ms ⇒ "m:ss", vd 7400 ⇒ "0:07", 15000 ⇒ "0:15"; âm hoặc không hợp lệ ⇒ "0:00". */
export const formatVoiceSeconds = (ms: number): string => {
  const safeMs = Number.isFinite(ms) && ms > 0 ? ms : 0;
  const totalSeconds = Math.floor(safeMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${`${seconds}`.padStart(2, '0')}`;
};
